import React from 'react';

const ArrowDown = () => {
  return (
    <svg
      width="9"
      height="5"
      viewBox="0 0 9 5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.84337 4.1756C4.65066 4.35766 4.34934 4.35766 4.15663 4.1756L0.650801 0.863449C0.322001 0.552814 0.541841 -7.62444e-07 0.994173 -7.229e-07L8.00583 -1.09922e-07C8.45816 -7.03775e-08 8.678 0.552815 8.3492 0.86345L4.84337 4.1756Z"
        fill="currentColor"
      />
    </svg>
  );
};

const ArrowDownLarge = () => {
  return (
    <svg
      width="12"
      height="6"
      viewBox="0 0 9 5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.84337 4.1756C4.65066 4.35766 4.34934 4.35766 4.15663 4.1756L0.650801 0.863449C0.322001 0.552814 0.541841 -7.62444e-07 0.994173 -7.229e-07L8.00583 -1.09922e-07C8.45816 -7.03775e-08 8.678 0.552815 8.3492 0.86345L4.84337 4.1756Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Light = () => {
  return (
    <svg
      width="63"
      height="64"
      viewBox="0 0 63 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M33.5 53H38.43C38.5626 53 38.6898 52.9473 38.7836 52.8536C38.8773 52.7598 38.93 52.6326 38.93 52.5V52.483L38.7785 48.0625C38.7697 47.8064 38.8267 47.5523 38.944 47.3245C39.0613 47.0966 39.235 46.9026 39.4485 46.761C43.2 44.2745 45.5 40.084 45.5 35.5C45.5 28.044 39.456 22 32 22C24.544 22 18.5 28.044 18.5 35.5C18.5 40.085 20.8015 44.2765 24.5535 46.7625C24.7528 46.8944 24.9176 47.0721 25.0344 47.2807C25.1511 47.4892 25.2163 47.7226 25.2245 47.9615L25.381 52.517C25.3854 52.6466 25.44 52.7695 25.5333 52.8596C25.6266 52.9497 25.7513 53.0001 25.881 53H30.5V42.845L26.9075 39.028C26.6349 38.7383 26.4885 38.3521 26.5006 37.9544C26.5066 37.7575 26.5513 37.5637 26.6322 37.3841C26.7131 37.2044 26.8285 37.0425 26.972 36.9075C27.1155 36.7725 27.2841 36.6671 27.4683 36.5973C27.6525 36.5274 27.8487 36.4946 28.0456 36.5006C28.4433 36.5127 28.8199 36.6823 29.0925 36.972L32.0625 40.128L35.47 36.9095C35.7592 36.6363 36.1451 36.4892 36.5428 36.5006C36.9405 36.5119 37.3173 36.6808 37.5905 36.97C37.8637 37.2592 38.0108 37.6451 37.9994 38.0428C37.9881 38.4405 37.8192 38.8173 37.53 39.0905L33.5 42.8965V53ZM48.5 35.5C48.502 38.0822 47.8972 40.6287 46.7342 42.9341C45.5713 45.2396 43.8828 47.2395 41.805 48.7725L41.9285 52.38C41.9446 52.8495 41.866 53.3174 41.6975 53.7559C41.5289 54.1944 41.2738 54.5945 40.9473 54.9323C40.6208 55.2701 40.2297 55.5387 39.7972 55.7221C39.3648 55.9056 38.8998 56.0001 38.43 56H25.88C24.9725 56 24.1005 55.6476 23.4479 55.017C22.7953 54.3864 22.4131 53.527 22.382 52.62L22.2515 48.814C20.1576 47.2828 18.4548 45.2789 17.2816 42.9654C16.1085 40.6518 15.498 38.094 15.5 35.5C15.5 26.3875 22.8875 19 32 19C41.1125 19 48.5 26.3875 48.5 35.5ZM27.5 61C27.1022 61 26.7206 60.842 26.4393 60.5607C26.158 60.2794 26 59.8978 26 59.5C26 59.1022 26.158 58.7206 26.4393 58.4393C26.7206 58.158 27.1022 58 27.5 58H36.5C36.8978 58 37.2794 58.158 37.5607 58.4393C37.842 58.7206 38 59.1022 38 59.5C38 59.8978 37.842 60.2794 37.5607 60.5607C37.2794 60.842 36.8978 61 36.5 61H27.5Z"
        fill="#00D6AF"
      />
      <line
        x1="32.5"
        y1="1.5"
        x2="32.5"
        y2="8.5"
        stroke="#00C6A2"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <line
        x1="50.5773"
        y1="6.05138"
        x2="47.0514"
        y2="12.0985"
        stroke="#00C6A2"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <line
        x1="61.2491"
        y1="20.4947"
        x2="54.6734"
        y2="22.8949"
        stroke="#00C6A2"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <line
        x1="1.5"
        y1="-1.5"
        x2="8.5"
        y2="-1.5"
        transform="matrix(0.939377 0.342886 0.342886 -0.939377 0.75 18.5713)"
        stroke="#00C6A2"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <line
        x1="1.5"
        y1="-1.5"
        x2="8.5"
        y2="-1.5"
        transform="matrix(0.503712 0.863872 0.863872 -0.503712 14 4)"
        stroke="#00C6A2"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  );
};

const UnLoginIcon = (props: any) => {
  const { width, height, color } = props;
  return (
    <svg
      width={width || '27'}
      height={height || '23'}
      viewBox="0 0 27 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.26316 4.74654V18.4045L11.3684 13.1863L12.0789 13.7988L6.12071 22.0476C3.9069 24.0438 0 22.6932 0 19.9315V3.06842C0 0.212095 4.13563 -1.08895 6.27008 1.09588L22.7368 17.9513V4.85377L16.3421 9.51153L15.6316 8.89907L20.6994 1.19909C22.8146 -1.02619 27 0.263066 27 3.13991V19.6294C27 22.4857 22.8644 23.7868 20.7299 21.602L4.26316 4.74654Z"
        fill={color || 'white'}
      />
    </svg>
  );
};

const QuestionMark = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.4375 9.19141C5.4375 9.50207 5.68934 9.75391 6 9.75391C6.31066 9.75391 6.5625 9.50207 6.5625 9.19141C6.5625 8.88074 6.31066 8.62891 6 8.62891C5.68934 8.62891 5.4375 8.88074 5.4375 9.19141Z"
        fill="#73818B"
      />
      <path
        d="M6 11.25C3.105 11.25 0.75 8.895 0.75 6C0.75 3.105 3.105 0.75 6 0.75C8.895 0.75 11.25 3.105 11.25 6C11.25 8.895 8.895 11.25 6 11.25ZM6 1.50336C3.5205 1.50336 1.50336 3.5205 1.50336 6C1.50336 8.47913 3.5205 10.4966 6 10.4966C8.47913 10.4966 10.4966 8.47914 10.4966 6C10.4966 3.5205 8.47913 1.50336 6 1.50336Z"
        fill="#73818B"
      />
      <path
        d="M6 7.89466C5.79299 7.89466 5.625 7.72666 5.625 7.51967V6.88554C5.625 6.27203 6.09374 5.8033 6.50774 5.38967C6.8111 5.08592 7.12499 4.77242 7.12499 4.5223C7.12499 3.89717 6.62024 3.38867 6 3.38867C5.36926 3.38867 4.875 3.87542 4.875 4.4968C4.875 4.7038 4.70701 4.87178 4.5 4.87178C4.29299 4.87178 4.125 4.70378 4.125 4.49678C4.125 3.4723 4.9661 2.63867 6 2.63867C7.0339 2.63867 7.875 3.48355 7.875 4.5223C7.875 5.08367 7.44937 5.50891 7.038 5.9203C6.71175 6.2458 6.37501 6.58255 6.37501 6.88516V7.51928C6.37501 7.72629 6.20701 7.89466 6 7.89466Z"
        fill="#73818B"
      />
    </svg>
  );
};

const Calc = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.6213 3.24316H4.66995V4.67019H3.24292V5.62154H4.66995V7.04857H5.6213V5.62154H7.04833V4.67019H5.6213V3.24316ZM6.15406 9.17008L5.14562 10.1833L4.13719 9.17008L3.46173 9.84554L4.47492 10.854L3.46173 11.8624L4.13719 12.5379L5.14562 11.5247L6.15406 12.5379L6.82951 11.8624L5.81633 10.854L6.82951 9.84554L6.15406 9.17008ZM8.95103 4.67019H12.7564V5.62154H8.95103V4.67019ZM8.95103 10.3783H12.7564V11.3297H8.95103V10.3783Z"
        fill="#00C6A2"
      />
      <path
        d="M10.3782 12.2813C10.3782 12.4075 10.4283 12.5285 10.5175 12.6177C10.6067 12.7069 10.7277 12.757 10.8539 12.757C10.98 12.757 11.101 12.7069 11.1902 12.6177C11.2794 12.5285 11.3295 12.4075 11.3295 12.2813C11.3295 12.1552 11.2794 12.0342 11.1902 11.945C11.101 11.8558 10.98 11.8057 10.8539 11.8057C10.7277 11.8057 10.6067 11.8558 10.5175 11.945C10.4283 12.0342 10.3782 12.1552 10.3782 12.2813Z"
        fill="#00C6A2"
      />
      <path
        d="M10.3782 9.42685C10.3782 9.553 10.4283 9.67399 10.5175 9.7632C10.6067 9.85241 10.7277 9.90252 10.8539 9.90252C10.98 9.90252 11.101 9.85241 11.1902 9.7632C11.2794 9.67399 11.3295 9.553 11.3295 9.42685C11.3295 9.30069 11.2794 9.1797 11.1902 9.09049C11.101 9.00129 10.98 8.95117 10.8539 8.95117C10.7277 8.95117 10.6067 9.00129 10.5175 9.09049C10.4283 9.1797 10.3782 9.30069 10.3782 9.42685Z"
        fill="#00C6A2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 3.24324C0 1.45205 1.45205 0 3.24324 0H12.7568C14.548 0 16 1.45205 16 3.24324V12.7568C16 14.548 14.548 16 12.7568 16H3.24324C1.45205 16 0 14.548 0 12.7568V3.24324ZM3.24324 1.2973C2.16853 1.2973 1.2973 2.16853 1.2973 3.24324V12.7568C1.2973 13.8315 2.16853 14.7027 3.24324 14.7027H12.7568C13.8315 14.7027 14.7027 13.8315 14.7027 12.7568V3.24324C14.7027 2.16853 13.8315 1.2973 12.7568 1.2973H3.24324Z"
        fill="#00C6A2"
      />
    </svg>
  );
};

const SwitchBtn = () => {
  return (
    <svg
      width="16"
      height="14"
      viewBox="0 0 16 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 5.15385H13.5385L9.38462 1"
        stroke="#00C6A2"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M14 8.84615L2.46154 8.84615L6.61538 13"
        stroke="#00C6A2"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};
const HandIcon = () => {
  return (
    <svg
      width="19"
      height="20"
      viewBox="0 0 19 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.6764 17.0996L1.33321 15.2351C0.92105 14.9112 0.557535 14.6935 0.812082 14.2353L2.06585 12.0667C2.81862 10.7117 4.24684 10.5195 5.79692 10.5195L10.1583 10.5195C11.3897 10.5195 12.3425 9.33839 13.2957 8.55864L15.6488 6.59774C16.6329 5.79263 17.6058 6.77049 16.8253 7.77429L12.14 13.8489C11.7357 14.3689 11.2913 14.6445 10.6326 14.6445L6.37338 14.673C5.95495 14.673 5.57513 14.9176 5.40198 15.2985L4.90397 16.6904C4.61774 17.3201 4.22031 17.5269 3.6764 17.0996Z"
        fill="#00C6A2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.98371 8.23381L9.76629 8.16686C10.6652 8.16687 11.9491 7.15831 12.8634 6.28205C12.0539 3.86985 8.96371 0.323242 8.96371 0.323242C8.96371 0.323242 4.87183 5.01956 4.87183 7.27945C4.87183 7.60806 4.91056 7.92762 4.98371 8.23381Z"
        fill="#00C6A2"
      />
    </svg>
  );
};

const LinkIcon = () => {
  return (
    <svg
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.96806 12.002H3.03194C1.36082 12.002 0 10.6412 0 8.97009V3.03194C0 1.36082 1.36082 0 3.03194 0H5.6096C5.97262 0 6.26669 0.294068 6.26669 0.65709C6.26669 1.02011 5.97262 1.31418 5.6096 1.31418H3.03194C2.5736 1.31418 2.14163 1.49265 1.81714 1.81714C1.49265 2.14163 1.31418 2.5736 1.31418 3.03194V8.96806C1.31418 9.4264 1.49265 9.85838 1.81714 10.1829C2.14163 10.5074 2.5736 10.6858 3.03194 10.6858H8.96806C9.91516 10.6858 10.6858 9.91516 10.6858 8.96806V6.19571C10.6858 5.96248 10.8116 5.74345 11.0144 5.62582C11.1137 5.56904 11.2273 5.53862 11.3429 5.53862C11.4585 5.53862 11.5721 5.56904 11.6715 5.62582C11.8743 5.74345 12 5.96045 12 6.19571V8.96806C12 10.6412 10.6412 12.002 8.96806 12.002ZM11.0288 4.17171C11.1242 4.22647 11.2337 4.25486 11.3432 4.25486C11.4527 4.25486 11.5622 4.22444 11.6596 4.16968C11.8543 4.05814 11.9739 3.84925 11.9739 3.62616V0.657093C11.9739 0.310295 11.692 0.0283954 11.3452 0.0283954H8.37614C8.02935 0.0283954 7.74745 0.310295 7.74745 0.657093C7.74745 1.00389 8.02935 1.28579 8.37614 1.28579H9.8261L5.55502 5.55687L5.55096 5.56093C5.43996 5.67997 5.37959 5.83751 5.38262 6.00024C5.38565 6.16298 5.45183 6.31816 5.56719 6.43299C5.68684 6.55265 5.843 6.61755 6.01133 6.61755C6.17155 6.61755 6.32365 6.55671 6.43925 6.44922L6.44128 6.44719L10.7145 2.17398V3.62819C10.7145 3.85128 10.8362 4.06017 11.0288 4.17171Z"
        fill="#00C6A2"
      />
    </svg>
  );
};
const ArrowDownHollow = () => {
  return (
    <svg
      width="10"
      height="6"
      viewBox="0 0 10 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.79995 0.267158C9.51417 -0.0663732 9.02768 -0.0909533 8.71332 0.212257L5 3.79397L1.28668 0.212256C0.972323 -0.090954 0.485825 -0.066374 0.200051 0.267157C-0.085723 0.600689 -0.0625573 1.11687 0.251795 1.42008L5 6L9.7482 1.42008C10.0626 1.11687 10.0857 0.60069 9.79995 0.267158Z"
        fill="currentColor"
      />
    </svg>
  );
};
const Checkbox = (props: any) => {
  return (
    <svg
      {...props}
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="15" height="15" rx="4" fill="#304452" />
    </svg>
  );
};
const CheckboxSelected = (props: any) => {
  return (
    <svg
      {...props}
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="15"
        height="15"
        rx="4"
        // fill="url(#paint0_linear_9045_6031)"
        fill="#00C6A2"
      />
      <path
        d="M4 7.5L6.66667 10L12 5"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_9045_6031"
          x1="7.5"
          y1="0"
          x2="7.5"
          y2="15"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00C6A2" />
          <stop offset="1" stopColor="#008B72" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export function CoinPropertyIcon(props: any) {
  const { className, ...rest } = props;
  return (
    <svg
      className={className}
      {...rest}
      width="14"
      height="10"
      viewBox="0 0 14 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line
        x1="0.75"
        y1="1.25"
        x2="13.25"
        y2="1.25"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <line
        x1="2.75"
        y1="5.25"
        x2="11.25"
        y2="5.25"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <line
        x1="4.75"
        y1="9.25"
        x2="9.25"
        y2="9.25"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function SortIcon(props: any) {
  const { className, ...rest } = props;
  return (
    <svg
      className={className}
      {...rest}
      width="15"
      height="12"
      viewBox="0 0 15 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line
        x1="0.75"
        y1="2.25"
        x2="7.25"
        y2="2.25"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <line
        x1="2.75"
        y1="6.25"
        x2="7.25"
        y2="6.25"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <line
        x1="5.75"
        y1="10.25"
        x2="7.25"
        y2="10.25"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M11 1L11 11L14 8.30769"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export function NoDataIcon() {
  return (
    <svg
      width="120"
      height="111"
      viewBox="0 0 120 111"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <ellipse
        cx="62.7519"
        cy="73.7613"
        rx="44.0366"
        ry="13.211"
        fill="url(#paint0_linear_13858_1144)"
      />
      <mask
        id="mask0_13858_1144"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="26"
        y="26"
        width="77"
        height="61"
      >
        <rect
          x="26.4219"
          y="26.4219"
          width="75.9632"
          height="60.5503"
          fill="#C4C4C4"
        />
      </mask>
      <g mask="url(#mask0_13858_1144)">
        <mask
          id="path-3-outside-1_13858_1144"
          maskUnits="userSpaceOnUse"
          x="26.9404"
          y="30.4963"
          width="72.3924"
          height="70.8149"
          fill="black"
        >
          <rect
            fill="white"
            x="26.9404"
            y="30.4963"
            width="72.3924"
            height="70.8149"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M28.3068 44.2039C28.2005 43.662 28.5536 43.1365 29.0955 43.0301L45.3749 39.8359C45.9169 39.7296 46.4424 40.0827 46.5487 40.6246L48.7114 51.6468C48.8829 52.521 47.9119 53.1662 47.1724 52.6693L44.551 50.9079C44.0926 50.5999 43.4713 50.7218 43.1632 51.1802L34.0705 64.7123C33.5736 65.4517 32.4307 65.2213 32.2591 64.3471L28.3068 44.2039ZM44.6818 58.9196C44.9898 58.4612 45.6111 58.3393 46.0696 58.6473L50.351 61.5242C50.5711 61.6721 50.7235 61.9014 50.7746 62.1617L57.2595 95.212C57.3658 95.754 57.0127 96.2795 56.4707 96.3859L40.1914 99.5801C39.6494 99.6864 39.1239 99.3333 39.0175 98.7913L34.3223 74.862C34.2712 74.6017 34.3256 74.3318 34.4736 74.1117L44.6818 58.9196ZM64.7899 37.0458C64.6835 36.5038 64.158 36.1507 63.616 36.257L49.1609 39.0933C48.6189 39.1997 48.2658 39.7252 48.3721 40.2671L51.278 55.0767C51.329 55.3369 51.4814 55.5663 51.7015 55.7142L59.3699 60.8669C59.8164 61.1669 60.4202 61.06 60.7365 60.625L67.3154 51.5766C67.4789 51.3517 67.5414 51.0688 67.4878 50.7959L64.7899 37.0458ZM69.4787 60.9423C69.3106 60.0854 68.2021 59.8405 67.6886 60.5467L62.0868 68.2513C61.7705 68.6863 61.1667 68.7932 60.7202 68.4932L54.8801 64.569C54.1407 64.0721 53.1696 64.7174 53.3411 65.5916L59.0829 94.8545C59.1892 95.3965 59.7148 95.7496 60.2567 95.6433L74.7119 92.807C75.2538 92.7007 75.607 92.1751 75.5006 91.6332L69.4787 60.9423ZM73.0403 69.4304C73.1407 69.9418 73.6246 70.2877 74.1359 70.1874V70.1874C83.7069 68.3095 89.9433 59.0282 88.0654 49.4572C87.392 46.0252 85.7666 43.0219 83.5173 40.6678C83.1041 40.2354 82.4072 40.3056 82.0555 40.7894L70.7872 56.2875C70.6236 56.5124 70.5611 56.7953 70.6147 57.0681L73.0403 69.4304ZM68.6238 46.9218C68.792 47.7786 69.9005 48.0236 70.4139 47.3173L77.3491 37.7789C77.7207 37.2678 77.531 36.5428 76.9395 36.3203C73.9744 35.2047 70.6724 34.8729 67.3352 35.5277V35.5277C66.8239 35.6281 66.5066 36.1313 66.6069 36.6426L68.6238 46.9218ZM97.4046 86.6147C98.1441 87.1116 97.9137 88.2545 97.0394 88.426L78.4995 92.0638C77.9575 92.1702 77.432 91.817 77.3256 91.2751L73.6878 72.7351C73.5163 71.8609 74.4874 71.2156 75.2269 71.7125L97.4046 86.6147Z"
          />
        </mask>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M28.3068 44.2039C28.2005 43.662 28.5536 43.1365 29.0955 43.0301L45.3749 39.8359C45.9169 39.7296 46.4424 40.0827 46.5487 40.6246L48.7114 51.6468C48.8829 52.521 47.9119 53.1662 47.1724 52.6693L44.551 50.9079C44.0926 50.5999 43.4713 50.7218 43.1632 51.1802L34.0705 64.7123C33.5736 65.4517 32.4307 65.2213 32.2591 64.3471L28.3068 44.2039ZM44.6818 58.9196C44.9898 58.4612 45.6111 58.3393 46.0696 58.6473L50.351 61.5242C50.5711 61.6721 50.7235 61.9014 50.7746 62.1617L57.2595 95.212C57.3658 95.754 57.0127 96.2795 56.4707 96.3859L40.1914 99.5801C39.6494 99.6864 39.1239 99.3333 39.0175 98.7913L34.3223 74.862C34.2712 74.6017 34.3256 74.3318 34.4736 74.1117L44.6818 58.9196ZM64.7899 37.0458C64.6835 36.5038 64.158 36.1507 63.616 36.257L49.1609 39.0933C48.6189 39.1997 48.2658 39.7252 48.3721 40.2671L51.278 55.0767C51.329 55.3369 51.4814 55.5663 51.7015 55.7142L59.3699 60.8669C59.8164 61.1669 60.4202 61.06 60.7365 60.625L67.3154 51.5766C67.4789 51.3517 67.5414 51.0688 67.4878 50.7959L64.7899 37.0458ZM69.4787 60.9423C69.3106 60.0854 68.2021 59.8405 67.6886 60.5467L62.0868 68.2513C61.7705 68.6863 61.1667 68.7932 60.7202 68.4932L54.8801 64.569C54.1407 64.0721 53.1696 64.7174 53.3411 65.5916L59.0829 94.8545C59.1892 95.3965 59.7148 95.7496 60.2567 95.6433L74.7119 92.807C75.2538 92.7007 75.607 92.1751 75.5006 91.6332L69.4787 60.9423ZM73.0403 69.4304C73.1407 69.9418 73.6246 70.2877 74.1359 70.1874V70.1874C83.7069 68.3095 89.9433 59.0282 88.0654 49.4572C87.392 46.0252 85.7666 43.0219 83.5173 40.6678C83.1041 40.2354 82.4072 40.3056 82.0555 40.7894L70.7872 56.2875C70.6236 56.5124 70.5611 56.7953 70.6147 57.0681L73.0403 69.4304ZM68.6238 46.9218C68.792 47.7786 69.9005 48.0236 70.4139 47.3173L77.3491 37.7789C77.7207 37.2678 77.531 36.5428 76.9395 36.3203C73.9744 35.2047 70.6724 34.8729 67.3352 35.5277V35.5277C66.8239 35.6281 66.5066 36.1313 66.6069 36.6426L68.6238 46.9218ZM97.4046 86.6147C98.1441 87.1116 97.9137 88.2545 97.0394 88.426L78.4995 92.0638C77.9575 92.1702 77.432 91.817 77.3256 91.2751L73.6878 72.7351C73.5163 71.8609 74.4874 71.2156 75.2269 71.7125L97.4046 86.6147Z"
          fill="url(#paint1_linear_13858_1144)"
        />
        <path
          d="M77.3256 91.2751L76.3443 91.4676L77.3256 91.2751ZM70.4139 47.3173L69.6051 46.7293L70.4139 47.3173ZM77.3491 37.7789L76.5403 37.1909L77.3491 37.7789ZM76.9395 36.3203L76.5874 37.2562L76.9395 36.3203ZM73.0403 69.4304L72.059 69.623L73.0403 69.4304ZM75.5006 91.6332L74.5193 91.8257L75.5006 91.6332ZM54.8801 64.569L55.4379 63.739L54.8801 64.569ZM67.6886 60.5467L68.4974 61.1348L67.6886 60.5467ZM69.4787 60.9423L70.46 60.7497L69.4787 60.9423ZM62.0868 68.2513L61.278 67.6632L62.0868 68.2513ZM60.7202 68.4932L61.278 67.6632L60.7202 68.4932ZM67.3154 51.5766L68.1242 52.1646L67.3154 51.5766ZM67.4878 50.7959L68.4691 50.6034L67.4878 50.7959ZM59.3699 60.8669L59.9277 60.0369L59.3699 60.8669ZM60.7365 60.625L61.5453 61.213L60.7365 60.625ZM51.7015 55.7142L52.2593 54.8842L51.7015 55.7142ZM64.7899 37.0458L65.7712 36.8532L64.7899 37.0458ZM34.4736 74.1117L33.6435 73.554L34.4736 74.1117ZM46.0696 58.6473L45.5118 59.4773L46.0696 58.6473ZM44.6818 58.9196L45.5118 59.4773L44.6818 58.9196ZM50.351 61.5242L50.9087 60.6942L50.351 61.5242ZM34.0705 64.7123L34.9005 65.27L34.0705 64.7123ZM48.7114 51.6468L47.7301 51.8393L48.7114 51.6468ZM70.7872 56.2875L69.9783 55.6994L70.7872 56.2875ZM70.6147 57.0681L71.596 56.8756L70.6147 57.0681ZM83.5173 40.6678L82.7943 41.3587L83.5173 40.6678ZM46.5487 40.6246L45.5674 40.8172L46.5487 40.6246ZM45.1824 38.8546L28.903 42.0488L29.2881 44.0114L45.5674 40.8172L45.1824 38.8546ZM49.6927 51.4542L47.53 40.4321L45.5674 40.8172L47.7301 51.8393L49.6927 51.4542ZM43.9933 51.7379L46.6147 53.4994L47.7301 51.8393L45.1087 50.0779L43.9933 51.7379ZM34.9005 65.27L43.9933 51.7379L42.3332 50.6225L33.2404 64.1545L34.9005 65.27ZM27.3255 44.3965L31.2778 64.5396L33.2404 64.1545L29.2881 44.0114L27.3255 44.3965ZM50.9087 60.6942L46.6273 57.8173L45.5118 59.4773L49.7933 62.3542L50.9087 60.6942ZM58.2408 95.0195L51.7559 61.9691L49.7933 62.3542L56.2782 95.4046L58.2408 95.0195ZM40.3839 100.561L56.6633 97.3672L56.2782 95.4046L39.9988 98.5988L40.3839 100.561ZM33.341 75.0545L38.0363 98.9839L39.9988 98.5988L35.3036 74.6694L33.341 75.0545ZM43.8518 58.3619L33.6435 73.554L35.3036 74.6694L45.5118 59.4773L43.8518 58.3619ZM49.3534 40.0746L63.8086 37.2383L63.4235 35.2757L48.9683 38.112L49.3534 40.0746ZM52.2593 54.8842L49.3534 40.0746L47.3909 40.4597L50.2967 55.2692L52.2593 54.8842ZM59.9277 60.0369L52.2593 54.8842L51.1438 56.5442L58.8122 61.6969L59.9277 60.0369ZM66.5065 50.9885L59.9277 60.0369L61.5453 61.213L68.1242 52.1646L66.5065 50.9885ZM63.8086 37.2383L66.5065 50.9885L68.4691 50.6034L65.7712 36.8532L63.8086 37.2383ZM62.8956 68.8394L68.4974 61.1348L66.8798 59.9587L61.278 67.6632L62.8956 68.8394ZM54.3224 65.3991L60.1625 69.3233L61.278 67.6632L55.4379 63.739L54.3224 65.3991ZM60.0642 94.662L54.3224 65.3991L52.3598 65.7841L58.1016 95.0471L60.0642 94.662ZM74.5193 91.8257L60.0642 94.662L60.4493 96.6246L74.9044 93.7883L74.5193 91.8257ZM68.4974 61.1348L74.5193 91.8257L76.4819 91.4406L70.46 60.7497L68.4974 61.1348ZM87.0841 49.6498C88.8557 58.6788 82.9724 67.4345 73.9434 69.2061L74.3284 71.1687C84.4414 69.1844 91.031 59.3776 89.0467 49.2647L87.0841 49.6498ZM82.7943 41.3587C84.9157 43.5788 86.4485 46.4106 87.0841 49.6498L89.0467 49.2647C88.3354 45.6398 86.6176 42.465 84.2403 39.977L82.7943 41.3587ZM71.596 56.8756L82.8643 41.3775L81.2466 40.2013L69.9783 55.6994L71.596 56.8756ZM74.0216 69.2379L71.596 56.8756L69.6334 57.2607L72.059 69.623L74.0216 69.2379ZM76.5403 37.1909L69.6051 46.7293L71.2228 47.9054L78.1579 38.367L76.5403 37.1909ZM67.5278 36.509C70.6775 35.891 73.791 36.2041 76.5874 37.2562L77.2917 35.3843C74.1577 34.2052 70.6673 33.8549 67.1427 34.5465L67.5278 36.509ZM69.6051 46.7293L67.5882 36.4501L65.6256 36.8351L67.6426 47.1143L69.6051 46.7293ZM78.692 93.0451L97.232 89.4073L96.8469 87.4447L78.3069 91.0825L78.692 93.0451ZM72.7066 72.9276L76.3443 91.4676L78.3069 91.0825L74.6691 72.5425L72.7066 72.9276ZM97.9624 85.7847L75.7846 70.8825L74.6691 72.5425L96.8469 87.4447L97.9624 85.7847ZM74.6691 72.5425L74.6691 72.5425L75.7846 70.8825C74.3057 69.8887 72.3635 71.1792 72.7066 72.9276L74.6691 72.5425ZM97.232 89.4073C98.9805 89.0643 99.4413 86.7785 97.9624 85.7847L96.8469 87.4447L96.8469 87.4447L97.232 89.4073ZM78.3069 91.0825L78.3069 91.0825L76.3443 91.4676C76.557 92.5515 77.6081 93.2578 78.692 93.0451L78.3069 91.0825ZM67.1427 34.5465C66.0565 34.7596 65.4255 35.8154 65.6256 36.8351L67.5882 36.4501C67.5889 36.4533 67.5888 36.4626 67.5816 36.4738C67.5778 36.4796 67.5713 36.4873 67.5607 36.4946C67.5494 36.5024 67.5373 36.5072 67.5278 36.509L67.1427 34.5465ZM69.6051 46.7293L69.6051 46.7293L67.6426 47.1143C67.9788 48.828 70.1958 49.3178 71.2228 47.9054L69.6051 46.7293ZM78.1579 38.367C78.8875 37.3635 78.5489 35.8573 77.2917 35.3843L76.5874 37.2562C76.5815 37.254 76.5688 37.2468 76.5573 37.2339C76.5471 37.2223 76.5428 37.2119 76.5411 37.206C76.5396 37.2003 76.5397 37.1961 76.5402 37.1932C76.5409 37.1891 76.5423 37.188 76.5403 37.1909L78.1579 38.367ZM73.9434 69.2061C73.9529 69.2042 73.9659 69.204 73.9793 69.207C73.9918 69.2098 74.0008 69.2144 74.0065 69.2184C74.0174 69.226 74.021 69.2346 74.0216 69.2379L72.059 69.623C72.2591 70.6427 73.2422 71.3818 74.3284 71.1687L73.9434 69.2061ZM74.9044 93.7883C75.9883 93.5756 76.6946 92.5245 76.4819 91.4406L74.5193 91.8257L74.5193 91.8257L74.9044 93.7883ZM58.1016 95.0471C58.3143 96.131 59.3654 96.8373 60.4493 96.6246L60.0642 94.662L60.0642 94.662L58.1016 95.0471ZM55.4379 63.739C53.9589 62.7452 52.0168 64.0357 52.3598 65.7841L54.3224 65.3991L54.3224 65.3991L55.4379 63.739ZM68.4974 61.1348L68.4974 61.1348L70.46 60.7497C70.1237 59.0361 67.9067 58.5462 66.8798 59.9587L68.4974 61.1348ZM61.278 67.6632L61.278 67.6632L60.1625 69.3233C61.0554 69.9233 62.263 69.7095 62.8956 68.8394L61.278 67.6632ZM68.1242 52.1646C68.4512 51.7148 68.5762 51.1491 68.4691 50.6034L66.5065 50.9885L66.5065 50.9885L68.1242 52.1646ZM58.8122 61.6969C59.7051 62.2969 60.9127 62.0831 61.5453 61.213L59.9277 60.0369L59.9277 60.0369L58.8122 61.6969ZM50.2967 55.2692C50.3988 55.7897 50.7035 56.2484 51.1438 56.5442L52.2593 54.8842L52.2593 54.8842L50.2967 55.2692ZM63.8086 37.2383L63.8086 37.2383L65.7712 36.8532C65.5585 35.7693 64.5074 35.0631 63.4235 35.2757L63.8086 37.2383ZM48.9683 38.112C47.8844 38.3247 47.1782 39.3758 47.3909 40.4597L49.3534 40.0746L49.3534 40.0746L48.9683 38.112ZM35.3036 74.6694L35.3036 74.6694L33.6435 73.554C33.3477 73.9943 33.2389 74.534 33.341 75.0545L35.3036 74.6694ZM39.9988 98.5988L39.9988 98.5988L38.0363 98.9839C38.2489 100.068 39.3 100.774 40.3839 100.561L39.9988 98.5988ZM56.2782 95.4046L56.2782 95.4046L56.6633 97.3672C57.7472 97.1545 58.4534 96.1034 58.2408 95.0195L56.2782 95.4046ZM46.6273 57.8173C45.7105 57.2012 44.4678 57.445 43.8518 58.3619L45.5118 59.4773L45.5118 59.4773L46.6273 57.8173ZM49.7933 62.3542L49.7933 62.3542L51.7559 61.9691C51.6537 61.4486 51.349 60.99 50.9087 60.6942L49.7933 62.3542ZM33.2404 64.1545L33.2404 64.1545L31.2778 64.5396C31.6209 66.2881 33.9067 66.7489 34.9005 65.27L33.2404 64.1545ZM45.1087 50.0779C44.1919 49.4618 42.9493 49.7057 42.3332 50.6225L43.9933 51.7379L43.9933 51.7379L45.1087 50.0779ZM47.7301 51.8393L47.7301 51.8393L46.6147 53.4994C48.0936 54.4931 50.0358 53.2027 49.6927 51.4542L47.7301 51.8393ZM69.9783 55.6994C69.6513 56.1493 69.5263 56.7149 69.6334 57.2607L71.596 56.8756L71.596 56.8756L69.9783 55.6994ZM28.903 42.0488C27.8191 42.2615 27.1128 43.3126 27.3255 44.3965L29.2881 44.0114L29.2881 44.0114L28.903 42.0488ZM84.2403 39.977C83.3654 39.0613 81.9385 39.2497 81.2466 40.2013L82.8643 41.3775C82.8659 41.3753 82.8622 41.3802 82.8518 41.3811C82.8463 41.3816 82.8364 41.3812 82.8237 41.3766C82.8095 41.3715 82.799 41.3636 82.7943 41.3587L84.2403 39.977ZM45.5674 40.8172L45.5674 40.8172L47.53 40.4321C47.3173 39.3482 46.2663 38.6419 45.1824 38.8546L45.5674 40.8172Z"
          fill="black"
          mask="url(#path-3-outside-1_13858_1144)"
        />
        <path
          d="M86.518 27.4643L77.099 29.3124C75.7876 29.5697 75.442 31.2841 76.5512 32.0294L87.8184 39.6003C88.9276 40.3456 90.3842 39.3778 90.1269 38.0664L88.2788 28.6474C88.1192 27.8345 87.3309 27.3048 86.518 27.4643Z"
          fill="#73818B"
          stroke="black"
        />
      </g>
      <mask id="path-6-inside-2_13858_1144" fill="white">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M62.7521 86.9726C87.0729 86.9726 106.789 81.0578 106.789 73.7616C106.789 71.8121 105.381 69.9612 102.854 68.2954C110.921 72.2332 120 80.8394 120 84.7713C120 94.4996 94.369 102.386 62.752 102.386C31.135 102.386 5.50439 94.4996 5.50439 84.7713C5.50439 81.1286 13.6784 73.4739 21.3667 69.2363C19.6513 70.6479 18.7155 72.172 18.7155 73.7616C18.7155 81.0578 38.4314 86.9726 62.7521 86.9726Z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M62.7521 86.9726C87.0729 86.9726 106.789 81.0578 106.789 73.7616C106.789 71.8121 105.381 69.9612 102.854 68.2954C110.921 72.2332 120 80.8394 120 84.7713C120 94.4996 94.369 102.386 62.752 102.386C31.135 102.386 5.50439 94.4996 5.50439 84.7713C5.50439 81.1286 13.6784 73.4739 21.3667 69.2363C19.6513 70.6479 18.7155 72.172 18.7155 73.7616C18.7155 81.0578 38.4314 86.9726 62.7521 86.9726Z"
        fill="#31373B"
      />
      <path
        d="M102.854 68.2954L103.293 67.3968L102.304 69.1303L102.854 68.2954ZM21.3667 69.2363L22.0022 70.0085L20.884 68.3606L21.3667 69.2363ZM105.789 73.7616C105.789 75.1008 104.88 76.5774 102.75 78.0882C100.645 79.5806 97.5359 80.9656 93.6033 82.1453C85.751 84.501 74.8432 85.9726 62.7521 85.9726V87.9726C74.9818 87.9726 86.0922 86.4867 94.178 84.061C98.2146 82.85 101.554 81.3882 103.907 79.7195C106.233 78.0693 107.789 76.0704 107.789 73.7616H105.789ZM102.304 69.1303C104.744 70.739 105.789 72.3283 105.789 73.7616H107.789C107.789 71.2958 106.018 69.1833 103.405 67.4605L102.304 69.1303ZM121 84.7713C121 83.4674 120.277 81.9772 119.279 80.5253C118.251 79.0306 116.814 77.411 115.143 75.8129C111.804 72.6188 107.434 69.4182 103.293 67.3968L102.416 69.1941C106.341 71.1104 110.544 74.1818 113.761 77.2582C115.368 78.7953 116.704 80.3106 117.631 81.6584C118.587 83.0491 119 84.1092 119 84.7713H121ZM62.752 103.386C78.6317 103.386 93.0473 101.407 103.526 98.1825C108.76 96.5722 113.068 94.6344 116.089 92.4363C119.089 90.2542 121 87.6766 121 84.7713H119C119 86.7301 117.707 88.7864 114.912 90.819C112.14 92.8357 108.064 94.6936 102.938 96.2709C92.6974 99.4219 78.4893 101.386 62.752 101.386V103.386ZM4.50439 84.7713C4.50439 87.6766 6.41527 90.2542 9.41492 92.4363C12.4365 94.6344 16.7444 96.5722 21.9777 98.1825C32.4567 101.407 46.8723 103.386 62.752 103.386V101.386C47.0147 101.386 32.8065 99.4219 22.5659 96.2709C17.4395 94.6936 13.3637 92.8357 10.5915 90.819C7.79734 88.7864 6.50439 86.7301 6.50439 84.7713H4.50439ZM20.884 68.3606C16.9597 70.5235 12.9234 73.5498 9.85811 76.5072C8.32577 77.9856 7.01341 79.4683 6.07629 80.8385C5.16623 82.1692 4.50439 83.5435 4.50439 84.7713H6.50439C6.50439 84.1777 6.8643 83.2292 7.72712 81.9676C8.56288 80.7456 9.77454 79.3669 11.2467 77.9465C14.1905 75.1065 18.0854 72.1867 21.8494 70.1121L20.884 68.3606ZM19.7155 73.7616C19.7155 72.5957 20.3999 71.327 22.0022 70.0085L20.7313 68.4642C18.9027 69.9689 17.7155 71.7483 17.7155 73.7616H19.7155ZM62.7521 85.9726C50.661 85.9726 39.7532 84.501 31.9009 82.1453C27.9683 80.9656 24.8588 79.5806 22.7546 78.0882C20.6245 76.5774 19.7155 75.1008 19.7155 73.7616H17.7155C17.7155 76.0704 19.2709 78.0693 21.5976 79.7195C23.9502 81.3882 27.2896 82.85 31.3262 84.061C39.412 86.4867 50.5225 87.9726 62.7521 87.9726V85.9726Z"
        fill="url(#paint2_linear_13858_1144)"
        mask="url(#path-6-inside-2_13858_1144)"
      />
      <path
        d="M92.4111 70.4585C88.4478 70.4585 75.3472 71.0093 75.3472 71.0093L82.5031 75.9634L87.4572 76.5136C91.9417 75.1579 90.2093 74.3117 90.2093 74.3117L99.5671 76.5136C97.9157 72.11 96.3744 70.4585 92.4111 70.4585Z"
        fill="#73818B"
        stroke="black"
      />
      <path
        d="M97.105 75.2125C102.917 77.0266 100.676 81.9438 99.2922 83.1593C98.0865 82.3837 95.9129 78.9801 93.493 78.6266C91.0731 78.2731 88.4238 79.3542 87.3595 80.0733C87.0962 79.7033 86.6608 78.5408 87.0263 76.8506C87.483 74.7378 89.8398 72.945 97.105 75.2125Z"
        fill="white"
        stroke="black"
      />
      <path
        d="M85.0072 92.8749C83.5989 92.1862 81.854 91.4621 81.6041 89.2745C81.2918 86.54 79.6543 84.3006 81.2544 82.7882C82.8546 81.2757 89.2114 76.7821 93.8365 78.47C98.4616 80.1578 103.333 86.9146 102.067 90.3834C100.801 93.8522 100.336 96.5649 94.8447 97.9677C91.375 98.8542 90.238 98.0082 90.1106 97.4272C89.745 98.9317 88.9033 102.041 88.4661 103.239C87.623 105.551 86.0006 107.842 83.2872 107.377C80.5755 106.912 82.6408 102.686 83.9287 98.4387C84.3775 96.9589 84.7517 94.8541 85.0072 92.8749Z"
        fill="white"
      />
      <path
        d="M85.0072 92.8749C83.5989 92.1862 81.854 91.4621 81.6041 89.2745C81.2918 86.54 79.6543 84.3006 81.2544 82.7882C82.8546 81.2757 89.2114 76.7821 93.8365 78.47C98.4616 80.1578 103.333 86.9146 102.067 90.3834C100.801 93.8522 100.336 96.5649 94.8447 97.9677C90.452 99.09 89.7982 97.4355 90.1983 97.0574C89.9023 98.347 88.9433 101.931 88.4661 103.239C87.623 105.551 86.0006 107.842 83.2872 107.377C80.5755 106.912 82.6408 102.686 83.9287 98.4387C84.7371 95.7731 85.3036 91.0798 85.3698 88.7449L84.2575 86.7666"
        stroke="black"
        strokeLinejoin="round"
      />
      <path
        d="M34.6151 78.1037C23.7118 80.3056 18.1254 83.5698 18.9122 87.0318C19.6989 90.4939 32.6279 89.6989 38.4605 88.5601L38.4613 82.432C37.7533 82.3553 37.012 82.3032 36.2665 82.2698L34.6151 78.1037Z"
        fill="#73818B"
      />
      <path
        d="M34.6151 78.1037L34.5162 77.6136C34.7534 77.5657 34.9908 77.6945 35.08 77.9195L34.6151 78.1037ZM18.9122 87.0318L19.3997 86.921L19.3997 86.921L18.9122 87.0318ZM38.4605 88.5601L38.9605 88.5601L38.9605 88.9719L38.5564 89.0508L38.4605 88.5601ZM38.4613 82.432L38.5152 81.935L38.9614 81.9833L38.9613 82.4321L38.4613 82.432ZM28.3693 82.432L28.2855 81.9391L28.3064 81.9355L28.3275 81.9337L28.3693 82.432ZM34.7141 78.5938C29.2826 79.6907 25.2211 81.0442 22.6283 82.5291C19.995 84.0372 19.0867 85.5436 19.3997 86.921L18.4246 87.1426C17.9508 85.058 19.4423 83.2013 22.1313 81.6613C24.8609 80.0981 29.0443 78.7186 34.5162 77.6136L34.7141 78.5938ZM19.3997 86.921C19.4623 87.1966 19.6519 87.4677 20.025 87.7282C20.4016 87.9912 20.9348 88.2206 21.6127 88.4097C22.9675 88.7878 24.7915 88.976 26.8054 89.0214C30.8272 89.1122 35.4817 88.6323 38.3647 88.0693L38.5564 89.0508C35.6067 89.6267 30.8804 90.1137 26.7829 90.0212C24.7372 89.975 22.8168 89.7839 21.3439 89.3729C20.6079 89.1676 19.9564 88.9 19.4525 88.5482C18.9452 88.194 18.5587 87.7326 18.4246 87.1426L19.3997 86.921ZM37.9605 88.56L37.9613 82.432L38.9613 82.4321L38.9605 88.5601L37.9605 88.56ZM38.4074 82.9291C37.7121 82.8537 36.9816 82.8023 36.2442 82.7693L36.2889 81.7703C37.0424 81.804 37.7945 81.8568 38.5152 81.935L38.4074 82.9291ZM36.2442 82.7693C34.3185 82.6832 32.3599 82.7232 30.8797 82.7852C30.1404 82.8162 29.5221 82.8525 29.089 82.8811C28.8725 82.8954 28.7024 82.9077 28.5867 82.9165C28.5289 82.9208 28.4847 82.9243 28.4551 82.9267C28.4403 82.9279 28.4291 82.9288 28.4217 82.9294C28.4181 82.9297 28.4153 82.9299 28.4135 82.93C28.4127 82.9301 28.412 82.9302 28.4116 82.9302C28.4114 82.9302 28.4113 82.9302 28.4112 82.9302C28.4111 82.9302 28.4111 82.9302 28.4111 82.9302C28.4111 82.9302 28.4111 82.9302 28.3693 82.432C28.3275 81.9337 28.3275 81.9337 28.3276 81.9337C28.3276 81.9337 28.3277 81.9337 28.3278 81.9337C28.328 81.9337 28.3282 81.9337 28.3285 81.9337C28.329 81.9336 28.3298 81.9335 28.3309 81.9335C28.333 81.9333 28.3361 81.933 28.3401 81.9327C28.3481 81.932 28.3599 81.9311 28.3754 81.9298C28.4064 81.9274 28.4521 81.9238 28.5114 81.9193C28.63 81.9103 28.8033 81.8978 29.0231 81.8833C29.4629 81.8542 30.0893 81.8174 30.8379 81.7861C32.3336 81.7234 34.3236 81.6824 36.2889 81.7703L36.2442 82.7693ZM28.359 81.9321L36.2563 81.7699L36.2768 82.7697L28.3796 82.9319L28.359 81.9321ZM28.3693 82.432C28.4531 82.9249 28.4531 82.9249 28.4531 82.9249C28.4531 82.9249 28.4531 82.9249 28.4531 82.9249C28.4531 82.9249 28.453 82.9249 28.4529 82.925C28.4526 82.925 28.4521 82.9251 28.4513 82.9252C28.4499 82.9255 28.4475 82.9259 28.4444 82.9264C28.4381 82.9275 28.4284 82.9292 28.4155 82.9315C28.3897 82.9361 28.3513 82.9431 28.3016 82.9523C28.2024 82.9709 28.0587 82.9987 27.8828 83.0355C27.5305 83.1091 27.052 83.2179 26.5449 83.3586C26.0361 83.4999 25.5086 83.6707 25.0544 83.8666C24.5869 84.0681 24.2521 84.2735 24.0784 84.4607L23.3453 83.7805C23.6657 83.4352 24.1601 83.1632 24.6585 82.9483C25.1703 82.7276 25.7454 82.5428 26.2774 82.3951C26.8112 82.2469 27.3117 82.1332 27.6783 82.0566C27.8618 82.0183 28.0125 81.9891 28.1178 81.9694C28.1704 81.9595 28.2118 81.9521 28.2402 81.947C28.2545 81.9445 28.2655 81.9425 28.2731 81.9412C28.2769 81.9405 28.2799 81.94 28.282 81.9397C28.283 81.9395 28.2838 81.9394 28.2844 81.9393C28.2847 81.9392 28.285 81.9392 28.2851 81.9391C28.2852 81.9391 28.2853 81.9391 28.2854 81.9391C28.2855 81.9391 28.2855 81.9391 28.3693 82.432ZM35.08 77.9195L36.7313 82.0856L35.8017 82.4541L34.1503 78.288L35.08 77.9195Z"
        fill="black"
      />
      <path
        d="M37.5297 84.0742C39.0112 80.8477 41.8128 79.6548 43.4146 81.893C42.8398 82.9813 42.9101 89.7001 42.9101 89.7001C44.0652 91.3141 39.7767 91.9427 38.368 90.9202C36.9592 89.8977 35.6778 88.1072 37.5297 84.0742Z"
        fill="white"
        stroke="black"
      />
      <path
        d="M50.1937 79.9197C43.5025 80.5316 42.2318 82.7125 41.7464 83.8438C41.121 85.0936 39.9939 86.9019 42.3581 90.5353C44.7222 94.1687 54.8202 96.1132 58.5721 94.7051C60.1332 94.1192 61.9564 93.2252 63.3492 92.3179C65.3036 91.0447 66.4105 89.7454 64.7565 89.2344C62.8033 88.6311 60.0681 88.0906 58.558 87.8131C60.461 88.1169 64.229 88.5655 65.1705 87.5439C66.8202 85.7537 54.8423 82.7842 54.8459 82.7839C62.5226 82.1113 55.2475 79.4576 50.1937 79.9197Z"
        fill="white"
      />
      <path
        d="M54.9693 91.1309C55.7305 91.4374 58.7267 92.2379 60.0405 92.3773C61.1545 92.4955 62.795 92.2933 63.3492 92.3179M63.3492 92.3179C61.9564 93.2252 60.1332 94.1192 58.5721 94.7051C54.8202 96.1132 44.7222 94.1687 42.3581 90.5353C39.9939 86.9019 41.121 85.0936 41.7464 83.8438C42.2318 82.7125 43.5025 80.5316 50.1937 79.9197C55.2475 79.4576 62.5226 82.1113 54.8459 82.7839C54.8423 82.7842 66.8202 85.7537 65.1705 87.5439C63.8965 88.9264 57.4462 87.6165 57.4462 87.6165C57.4462 87.6165 61.9237 88.3594 64.7565 89.2344C66.4105 89.7454 65.3036 91.0447 63.3492 92.3179Z"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.1354 60.6282L23.1351 60.6278C22.5643 59.8657 22.4999 59.0251 22.7907 58.1372C23.0883 57.2287 23.7569 56.2879 24.6235 55.4234L24.8977 55.1498L24.7013 54.8159C22.2814 50.7024 20.6721 45.8917 20.4194 41.3257C20.1669 36.7607 21.2702 32.4834 24.2187 29.3597L24.2531 29.3233L24.2796 29.2807C24.7315 28.5544 26.2497 26.2292 27.9789 24.9405L27.9789 24.9405L27.979 24.9405L27.979 24.9405L27.979 24.9405L27.979 24.9405L27.979 24.9404L27.979 24.9404L27.979 24.9404L27.9791 24.9404L27.9791 24.9404L27.9791 24.9404L27.9791 24.9404L27.9791 24.9404L27.9791 24.9404L27.9792 24.9404L27.9792 24.9403L27.9792 24.9403L27.9792 24.9403L27.9792 24.9403L27.9792 24.9403L27.9792 24.9403L27.9793 24.9403L27.9793 24.9403L27.9793 24.9403L27.9793 24.9402L27.9793 24.9402L27.9793 24.9402L27.9794 24.9402L27.9794 24.9402L27.9794 24.9402L27.9794 24.9402L27.9794 24.9402L27.9794 24.9401L27.9795 24.9401L27.9795 24.9401L27.9795 24.9401L27.9795 24.9401L27.9795 24.9401L27.9795 24.9401L27.9796 24.9401L27.9796 24.9401L27.9796 24.94L27.9796 24.94L27.9796 24.94C29.8322 23.6325 32.2346 23.1855 33.0924 23.0666L33.158 23.0576L33.219 23.0317C38.7006 20.708 43.8088 21.8331 48.0349 24.0974C52.2712 26.3671 55.5829 29.7645 57.4035 31.8969L57.6393 32.1732L57.9749 32.0343C58.8967 31.6528 59.8866 31.3589 60.7596 31.3935C61.5945 31.4265 62.3155 31.7552 62.8071 32.6572L62.8212 32.6832L62.8383 32.7073C62.9585 32.8768 63.1409 33.4225 63.0217 34.4155C62.9055 35.3838 62.5072 36.7198 61.5615 38.4001C59.6687 41.7628 55.6036 46.4677 47.3415 52.2989C41.5765 56.3677 36.0489 59.2671 31.6596 60.7163C29.4622 61.4418 27.5781 61.7943 26.1058 61.7644C24.6259 61.7343 23.6546 61.3229 23.1354 60.6282ZM22.7349 60.9275L22.7356 60.9269L22.7349 60.9275Z"
        fill="#454545"
        stroke="black"
      />
      <path
        d="M29.7494 55.322C32.2551 54.4439 38.6361 51.6594 44.1151 47.5451C49.5942 43.4308 53.8508 38.9993 55.9142 36.6586"
        stroke="#777777"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M34.9288 35.6575C31.4699 37.7257 26.9428 32.1176 25.1116 29.055C25.4366 28.3716 26.6271 26.6815 28.789 25.3889C30.9508 24.0964 32.6427 24.0629 33.2184 24.2078C35.2297 27.1627 38.3877 33.5894 34.9288 35.6575Z"
        fill="#777777"
      />
      <defs>
        <linearGradient
          id="paint0_linear_13858_1144"
          x1="62.7519"
          y1="60.5503"
          x2="62.7519"
          y2="86.9723"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4E4E4E" />
          <stop offset="1" stopColor="#010101" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_13858_1144"
          x1="37.0252"
          y1="41.4742"
          x2="48.1211"
          y2="98.0245"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#B7B7B7" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_13858_1144"
          x1="62.752"
          y1="102.386"
          x2="62.752"
          y2="67.158"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A8A8A8" />
          <stop offset="1" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export {
  ArrowDown,
  Light,
  UnLoginIcon,
  QuestionMark,
  Calc,
  SwitchBtn,
  HandIcon,
  LinkIcon,
  ArrowDownHollow,
  Checkbox,
  CheckboxSelected,
  ArrowDownLarge,
};
